<template>
  <div id="app" v-if="!routesWithoutLayout.includes($route.name)">
    <Loader v-if="getLoaderAction" />
    <Header />
    <router-view />
    <!-- <Footer /> -->
    <AcceptTerms
      v-if="!getAcceptedTermsCookie && !canCloseAcceptTerms"
      @accepted="canCloseAcceptTerms = true"
    />
    <UpdateApp
      v-if="showUpdateApp"
      :registration="registration"
      @updated="showUpdateApp = false"
      @closed="showUpdateApp = false"
    />
  </div>
  <div v-else>
    <Loader v-if="getLoaderAction" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';

import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Loader from './components/Loader.vue';
import AcceptTerms from './components/AcceptTerms.vue';
import UpdateApp from './components/UpdateApp.vue';
import PaymentsApp from './views/PaymentsApp.vue';

const infoToken = localStorage.getItem('token');

if (infoToken == null) {
  localStorage.setItem('token', null);
}

export default {
  app: 'home',
  data() {
    return {
      canCloseAcceptTerms: false,
      showUpdateApp: false,
      registration: null,
      routesWithoutLayout: [
        'checkout-pagamento-construp',
        'admin-impersonate-login',
      ],
    };
  },
  components: {
    Header,
    Footer,
    Loader,
    AcceptTerms,
    UpdateApp,
    PaymentsApp,
  },
  created() {
    document.addEventListener('serviceWorkerUpdated', this.showRefreshUi, {
      once: true,
    });
  },
  methods: {
    showRefreshUi(registration) {
      this.registration = registration.detail;
      this.showUpdateApp = true;
    },
  },
  computed: {
    ...mapGetters(['getLoaderAction']),
    getAcceptedTermsCookie() {
      return this.$cookies.get('accepted_terms');
    },
  },
};
</script>

<style>
@import './custom/css/style.css';
@import './custom/css/breadcrumbs.css';
@import './custom/css/header.css';

/*Fonts used in all project*/
@font-face {
  font-family: Oswald;
  src: url('~@/assets/fonts/Oswald/Oswald-Bold.ttf');
  font-weight: bold;
  font-display: swap;
}
@font-face {
  font-family: Oswald;
  src: url('~@/assets/fonts/Oswald/Oswald-Regular.ttf');
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: Inter;
  src: url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: Inter;
  src: url('https://fonts.googleapis.com/css2?family=Inter:wght@700&display=swap');
  font-weight: bold;
  font-display: swap;
}

@font-face {
  font-family: Roboto;
  src: url('~@/assets/fonts/Roboto/Roboto-Bold.ttf');
  font-weight: bold;
  font-display: swap;
}
@font-face {
  font-family: Roboto;
  src: url('~@/assets/fonts/Roboto/Roboto-Regular.ttf');
  font-weight: normal;
  font-display: swap;
}
</style>
